import { createContext, useContext } from 'react';
import type { HostInfo } from '@buildiary/core';

/** Which address the app was opened on (GET /api/host): a workspace, my.buildiary.app, the demo, or anything else. */
export const OTHER_HOST: HostInfo = { kind: 'other', host: '', workspace: null, known: true, baseDomain: null, myUrl: null, websiteUrl: 'https://buildiary.app', demoUrl: null, signupOpen: true };

export const HostContext = createContext<HostInfo>(OTHER_HOST);

export function useHost(): HostInfo {
  return useContext(HostContext);
}

/** A link on my.buildiary.app (sign-up, find my workspace), or on this address when there are no address rules. */
export function myLink(h: HostInfo, path: string): string {
  return h.myUrl && h.kind !== 'my' && h.kind !== 'other' ? `${h.myUrl}${path}` : path;
}
